// extracted by mini-css-extract-plugin
export default {"heightMapExtentsSliderInner":"styles_heightMapExtentsSliderInner__M5+DT"};